import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseService } from '../../../services/course.service';

@Component({
  selector: 'app-course-id',
  templateUrl: './course-id.component.html',
  styleUrl: './course-id.component.scss',
})
export class CourseIdComponent implements OnInit {
  courseId: string | null =
    inject(ActivatedRoute).snapshot.paramMap.get('courseId');

  constructor(
    protected courseService: CourseService,
    protected router: Router
  ) {}

  ngOnInit() {
    if (!this.courseId) {
      console.error('No course id');
      return;
    }

    this.courseService.listCourses([this.courseId]).subscribe(() => {
      this.getLessons();
    });
  }

  getLessons() {
    const course = this.courseService.courses$.value.find(
      (course) => course.id === this.courseId
    );

    if (!course) {
      console.error('No course found for', this.courseId);
      return;
    }

    this.courseService.listLessons(course.lessons).subscribe();
  }

  get lessons() {
    return this.courseService.lessions$.value;
  }

  openLesson(lessionId: string) {
    this.router.navigate(['/courses', this.courseId, 'lessons', lessionId]);
  }
}
